import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'navigation-west', 'NavigationWest', [["path",{"d":"M9 3l1 6l2 -3.75l2 3.75l1 -6"}],["path",{"d":"M16 21l-4 -8l-4 8l4 -2l4 2"}]]);